import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import { Link, Container, Typography, Divider, Stack, Button } from '@mui/material';
// sections
import { LoginForm } from '../sections/auth/login';
import MainSettingForm from 'src/sections/@dashboard/settings/MainSettingForm';
import AppUnderMaintance from 'src/sections/@dashboard/settings/AppUnderMaintance';
import AdminPaymentDetails from 'src/sections/@dashboard/settings/AdminPaymentDetails';
import ShareWithFriends from 'src/sections/@dashboard/settings/ShareWithFriends';
import { loadingStartAction, loadingStopAction } from 'src/redux/actions/loadingActions';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import api from 'src/api';
import AdminChangePassword from 'src/sections/@dashboard/settings/AdminChangePassword';
import AppSettings from 'src/sections/@dashboard/settings/AppSettings';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 480,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
  padding: 20,
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  // padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function SettingPage() {
  const dispatch = useDispatch();
  const [data, setData] = useState("")
  const [loading, setLoading] = useState(true)

  const getAllSettings = async () => {
    dispatch(loadingStartAction());
    setLoading(true)
    const response = await api.get('/settings');
    setData(response.data)
    setLoading(false)
    dispatch(loadingStopAction());
  };

  useEffect(() => {
    getAllSettings()
  }, [])
  
  if(loading) return <h1>Loading....</h1>
  return (
    <>
      <Helmet>
        <title> Setting | Minimal UI </title>
      </Helmet>

      <StyledRoot>
        <StyledSection>
          <h3>Add Value's Limit</h3>
          <MainSettingForm data={data} getAllSettings={getAllSettings}/>
        </StyledSection>

        <Container maxWidth="sm">
          <StyledSection>
            <h3>Admin Payment Details</h3>
            <AdminPaymentDetails data={data} getAllSettings={getAllSettings}/>
          </StyledSection>
          <br />
          <StyledSection>
            <h3>Share With Friends</h3>
            <ShareWithFriends data={data} getAllSettings={getAllSettings}/>
          </StyledSection>
          <br />
          <StyledSection>
            <h3>Change Password</h3>
            <AdminChangePassword data={data} getAllSettings={getAllSettings} />
          </StyledSection>

          <br />
          <StyledSection>
            <h3>App Settings</h3>
            <AppSettings data={data} getAllSettings={getAllSettings} />
          </StyledSection>
        </Container>
      </StyledRoot>
      <br />
    </>
  );
}
